module.exports = __webpack_public_path__ + "static/media/fmla-hours.d98cdd9a.png";